<template>
    <div v-if="totalItems > 0" class="px-3 py-1 rounded-full border-[1px] border-[#CCCCCC] bg-white">
        <p class="m-0 text-[16px] font-roboto text-[#999999]">{{ paginationText }}</p>
    </div>
</template>
<script>
export default {
    props: ["currentPage", "perPage", "totalItems"],

    computed: {
        paginationText() {
            let start_index = (this.currentPage - 1) * this.perPage + 1
            let end_index = Math.min(this.currentPage * this.perPage, this.totalItems)
            return `Showing ${start_index} to ${end_index} of ${this.totalItems} entries`
        }
    }
}
</script>
